// Every sphere on the field.
export const ORB_PX = 172;
// The opened cluster, flying orb and graph root alike: it grows from ORB_PX as it lands.
export const STAGE_ORB_PX = 260;
